import { DurationUtil } from "./DurationUtil";
var PredecessorUtil = /** @class */ (function () {
    function PredecessorUtil() {
    }
    PredecessorUtil.convertPredecessorToString = function (predecessor) {
        var DEFAULT_DEPENDENCY_TYPE = "FS";
        var typeString = predecessor.lag || predecessor.dependencyType != DEFAULT_DEPENDENCY_TYPE ? predecessor.dependencyType : "";
        var sign = predecessor.lag && !predecessor.lag.isNegative ? "+" : "";
        var lagString = predecessor.lag ? " " + sign + DurationUtil.convertDurationToString(predecessor.lag) : "";
        return "" + predecessor.rowNumber + typeString + lagString;
    };
    return PredecessorUtil;
}());
export { PredecessorUtil };
//# sourceMappingURL=PredecessorUtil.js.map